import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import IconButton from '@material-ui/core/IconButton'
import EditIcon from 'components/material-symbol/icons/Edit'
import useChromeStyles from 'pages/schedule/SelectLessonTime/redesign/styles'
import useStyles from './styles'

// The slot picked on step 1, with a pencil that goes back to change it.
const YourTimeCard = ({ slotLabel, editUrl }) => {
  const classes = useStyles()
  const chrome = useChromeStyles()

  if (!slotLabel) return null

  return (
    <section className={classes.yourTime} aria-label="Your time">
      <div>
        <span className={classes.yourTimeLabel}>Your time</span>
        <p className={classes.yourTimeValue}>{slotLabel}</p>
      </div>
      <IconButton
        component={Link}
        to={editUrl}
        aria-label="Change time"
        className={chrome.roundButton}
      >
        <EditIcon aria-hidden="true" />
      </IconButton>
    </section>
  )
}

YourTimeCard.propTypes = {
  slotLabel: PropTypes.string,
  editUrl: PropTypes.string.isRequired,
}

export default YourTimeCard
